import MainLayout from "../components/layouts/MainLayout";
import LoginForm from "../components/forms/LoginForm";

const LoginPage = () => {
    return <>
        <MainLayout>
            <LoginForm/>
        </MainLayout>
    </>
}

export default LoginPage